var map = {
	"./site-logo-desktop-footer.svg": 6994,
	"./site-logo-desktop.svg": 73634,
	"./site-logo-drawer-mobile.svg": 76536,
	"./site-logo-drawer.svg": 3549,
	"./site-logo-external.svg": 68951,
	"./site-logo-mobile-drawer.svg": 41218,
	"./site-logo-mobile.svg": 78400,
	"./site-logo-sm.svg": 20762,
	"./site-logo-tv.svg": 83080,
	"./site-logo-wrapper-mobile-scrolled.svg": 23627,
	"./site-logo-wrapper-mobile.svg": 25586,
	"./site-logo-wrapper-scrolled.svg": 35036,
	"./site-logo-wrapper.svg": 25171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72906;